// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"816":"79848c97f233be016e1b","839":"e24379d51ff574ca55ad","899":"7de812b38a7eb1a13731"}[chunkId] + ".js";
};